export default __webpack_public_path__ + "static/media/no-news.be084c33.svg";